// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"FA-z","smallCardRow":"GA-z","largeCardRow":"HA-z","productSearchRow":"IA-z","curatedRow":"JA-z"};